import { render, staticRenderFns } from "./input-checkbox.vue?vue&type=template&id=439df6f8&scoped=true"
import script from "./input-checkbox.vue?vue&type=script&lang=js"
export * from "./input-checkbox.vue?vue&type=script&lang=js"
import style0 from "./input-checkbox.vue?vue&type=style&index=0&id=439df6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439df6f8",
  null
  
)

export default component.exports